import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { TotalWeightLossState } from '@common/enums/totalWeightLossState';
import { gewichtInKgSchema } from '@common/validation/schemas';
import { totalWeightLossSchema } from '@common/validation/schemas/caroSchemas';
import { bariPostCaroWeightMeasurementsReadSchema } from '../../bariPostCaroBodyWeightMeasurements/v1/bariPostCaroBodyWeightMeasurementsSchemaV1';

export type BariPostFollowUpWeightMeasurementsData = {
    date: Date | string;
    totalWeightLoss: number;
    totalWeightLossState: TotalWeightLossState;
    weight: number;
};

export const bariPostFollowUpWeightMeasurementsReadSchema = bariPostCaroWeightMeasurementsReadSchema;

const bariPostFollowUpWeightMeasurementsFinal: TypedSchema<BariPostFollowUpWeightMeasurementsData> = {
    date: Koi.string().isoDate(),
    totalWeightLoss: totalWeightLossSchema,
    totalWeightLossState: Koi.koi().enum(TotalWeightLossState),
    weight: gewichtInKgSchema,
};

export const bariPostFollowUpWeightMeasurementsDraftSchema = Koi.object(bariPostFollowUpWeightMeasurementsFinal);
export const bariPostFollowUpWeightMeasurementsFinalSchema = Koi.object(bariPostFollowUpWeightMeasurementsFinal);
